import apiClient from './config';

export default {
  // Récupérer tous les clients
  getAllClients(params = {}) {
    return apiClient.get('/firm/clients', { params });
  },

  // Récupérer un client par ID
  getClientById(id) {
    return apiClient.get(`/firm/clients/${id}`);
  },

  // Créer un nouveau client
  createClient(data) {
    return apiClient.post('/firm/clients', data);
  },

  // Mettre à jour un client
  updateClient(id, data) {
    return apiClient.put(`/firm/clients/${id}`, data);
  },

  // Supprimer un client
  deleteClient(id) {
    return apiClient.delete(`/firm/clients/${id}`);
  },

  // Blacklister un client
  blacklistClient(id, status) {
    return apiClient.patch(`/firm/clients/${id}/blacklist`, { blacklisted: status });
  },

  // Mettre à jour les conditions d'acompte
  updateClientDeposit(id, depositData) {
    return apiClient.patch(`/firm/clients/${id}/deposit`, depositData);
  },

  // Récupérer l'historique des séances d'un client
  getClientSessions(id) {
    return apiClient.get(`/firm/clients/${id}/sessions`);
  },

  // Récupérer les acomptes d'un client
  getClientDeposits(id) {
    return apiClient.get(`/firm/clients/${id}/deposits`);
  },

  // Mettre à jour le profil de risque
  updateRiskProfile(id, riskData) {
    return apiClient.patch(`/firm/clients/${id}/risk-profile`, riskData);
  },

  // Rechercher des clients
  searchClients(query) {
    return apiClient.get('/firm/clients/search', { params: { q: query } });
  },
};
